import { render, staticRenderFns } from "./MagicInfoDisplayTimers.vue?vue&type=template&id=737bfbf6&scoped=true&"
import script from "./MagicInfoDisplayTimers.vue?vue&type=script&lang=js&"
export * from "./MagicInfoDisplayTimers.vue?vue&type=script&lang=js&"
import style0 from "./MagicInfoDisplayTimers.vue?vue&type=style&index=0&id=737bfbf6&scoped=true&lang=scss&"
import style1 from "./MagicInfoDisplayTimers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737bfbf6",
  null
  
)

export default component.exports